import React from "react";
import { RouteTypeIndicator } from "./RouteTypeIndicator";
import { PropertyDropdown } from "./PropertyDropdown";

const routeTypeOptions = [
    { name: 'Tramwajowa', value: 0 },
    { name: 'Metro', value: 1 },
    { name: 'Kolejowa', value: 2 },
    { name: 'Autobusowa', value: 3 },
    { name: 'Prom, statek, tramwaj wodny', value: 4 },
    { name: 'Kolej linowa, gondolowa, podwieszana', value: 6 },
    { name: 'Kolej linowo-terenowa', value: 7 },
    { name: 'Trolejbusowa', value: 11 },
    { name: 'Monorail (kolej jednoszynowa)', value: 12 }
];

const routeTypeOptionTemplate = (option) => {
    return (
        <div className="flex align-items-center">
            <RouteTypeIndicator GRoute={{route_type: option.value, suspended: false}} style={{marginRight: '1.5rem'}}/> {option.name}
        </div>
    )
}

const routeTypeSelectedTemplate = (option, props) => {
    if (option) {
        return (
            <div className="flex align-items-center">
                <RouteTypeIndicator GRoute={{route_type: option.value, suspended: false}} style={{marginRight: '1.5rem'}} /> {option.name}
            </div>
        )            
    } else {
        return <span>{props.placeholder}</span>
    }

}

export function RouteTypePropertyDropdown({propertyName, initialVal, label, onDone}) {

    return (
        <PropertyDropdown 
            propertyName={propertyName}
            initialVal={initialVal} 
            label={label} 
            options={routeTypeOptions} 
            onDone={onDone} 
            itemTemplate={routeTypeOptionTemplate}
            valueTemplate={routeTypeSelectedTemplate}
        />
    )
}